import React from 'react'
import { Button } from '@mui/material'
import './index.scss'

import ChildPageHeader from '@/components/UI/ChildPageHeader'
import { useTranslation } from 'react-i18next'
import { useQuizImport } from '@/hooks/useQuizImport'
import DocumentUploadSection from '@/components/Quizzes/DocumentUploadSection'
import QuizImportInstructions from '@/components/Quizzes/QuizImportInstructions'

const ImportQuestionBank: React.FC = () => {
  const { t } = useTranslation('translation')
  const {
    documents,
    isFileUploading,
    selectedUploadType,
    handleFileSelection,
    handleFileRemove,
    handleImport,
  } = useQuizImport({ mode: 'import-question-bank' })

  return (
    <section className="page-mid-wraper h-without-foter">
      <ChildPageHeader
        title={t('Import questions to question bank')}
        subTitle={t(
          'Upload a document containing questions to add to your question bank',
        )}
        slot={{
          action: (
            <Button
              variant="contained"
              size="medium"
              disabled={isFileUploading}
              onClick={handleImport}
            >
              {t('Import Questions')}
            </Button>
          ),
        }}
      />

      <div className="upload-document-page-container add-faq-container">
        <div className="page-content-container">
          {selectedUploadType === 'customtemplates' && (
            <React.Fragment>
              <QuizImportInstructions />

              <DocumentUploadSection
                documents={documents}
                onFilesSelected={files =>
                  handleFileSelection(files, 'customtemplates')
                }
                onFileRemove={handleFileRemove}
                isUploading={isFileUploading}
                supportedTypes=".docx, .txt, .pdf"
              />
            </React.Fragment>
          )}
        </div>
      </div>
    </section>
  )
}

export default ImportQuestionBank
